const state = {
  // 当前tab下标
  currentTab: 2
}
 
const mutations = {
  // 改变当前tab下标
  handleCurrentTab(state, index) {
    state.currentTab = index
  }
}
 
const actions = {
 
}
 
export default {
  namespaced: true,
  state,
  mutations,
  actions
}